var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmsCampaignMessageBgImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 145,
    viewBox: "0 0 272 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.11315 144.185C5.31315 144.985 10.4465 142.121 12.1132 140.288C10.3953 136.191 21.0011 126.242 14.0011 126.241C12.3825 126.241 11 122.001 5.11315 125.185C5.09194 126.471 5.11315 130.926 5.11315 131.684C5.11315 142.184 -0.88685 143.581 0.11315 144.185Z",
    fill: "#E9E9EB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.09961,
    width: 266.9,
    height: 144,
    rx: 18,
    fill: "#E9E9EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsCampaignMessageBgImg);
export default __webpack_public_path__ + "static/media/SMS_campaign_message_bgImg.aa4436dcf9676415f1506ee1bee00c85.svg";
export { ForwardRef as ReactComponent };